import React from 'react';
import PropTypes from 'prop-types';
import sanitizeHtml from 'util/sanitize/sanitizeHtml';

export const BallotDetail = ({ text }) => (
  <div
    className="ballot-detail"
    dangerouslySetInnerHTML={{ __html: sanitizeHtml(text) }}
  />
);

export default BallotDetail;

BallotDetail.propTypes = {
  text: PropTypes.string.isRequired,
};
